<template>
<div class="footer">
  <v-footer class="elevation-2 white">
    <v-container>
      <v-row>
        <v-col v-if="isAuthenticated" cols="6" md="4" class="pb-0">
          <div v-for="page in easyNav" :key="page.name">
            <v-btn
              height="28px"
              class="text-body-1 text-capitalize mb-2"
              :to="page.url"
              text
            >
              {{ page.name }}
            </v-btn>
          </div>
        </v-col>
        <v-col cols="6" md="4" class="pb-0">
          <div v-for="page in legalPages" :key="page.name">
            <v-btn
              height="28px"
              class="text-body-1 text-capitalize mb-2"
              :to="page.url"
              text
            >
              {{ page.name }}
            </v-btn>
          </div>
        </v-col>
        <v-col cols="6" md="4" class="pb-0">
          <div v-for="page in helpPages" :key="page.name">
            <v-btn
              height="28px"
              class="text-body-1 text-capitalize mb-2"
              :to="page.url"
              text
            >
              {{ page.name }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-divider class="mt-5 mb-5 grey lighten-4"></v-divider>
      <v-row>
        <v-col cols="12" md="12">
          <v-card-text class="text text-center pt-2 pb-2">
            <v-btn
              v-for="link in links"
              :key="link.icon"
              :color="link.color"
              class="mx-3"
              icon
              :href="link.url"
              target="_blank"
              exact
            >
              <v-icon size="34px">{{ link.icon }}</v-icon>
            </v-btn>
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
  <v-bottom-navigation class="elevation-0">
    <v-card-text class="body-1 text-center"
      >&copy; {{ new Date().getFullYear() }}
      <a
        @mouseenter="hover = true"
        @mouseleave="hover = false"
        :class="{ active: hover }"
        height="0"
        href="https://www.pjili.com/"
        target="_blank"
        class="link pa-0 text-capitalize font-weight-regular"
        >Pjili Corp</a
      >
      - All rights reserved
    </v-card-text>
  </v-bottom-navigation>
</div>
  
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["isAuthenticated"]),
  data: () => ({
    hover: false,
    links: [
      {
        icon: "mdi-instagram",
        url: "https://www.instagram.com/pjiliauctions",
        color: "red lighten-3",
      },
      {
        icon: "mdi-facebook",
        url: "https://fb.me/PjiliAuctions",
        color: "indigo",
      },
      {
        icon: "fab fa-twitter",
        url: "https://twitter.com/AuctionsPjili",
        color: "cyan",
      },
      {
        icon: "fab fa-tiktok",
        url: "https://www.tiktok.com/@pjiliauctions",
        color: "grey darken-4",
      },
    ],
    easyNav: [
      {
        name: "Won Auctions",
        url: "/auctions-won",
      },
      {
        name: "Account Details",
        url: "/profile",
      },
    ],
    legalPages: [
      {
        name: "Partner with us",
        url: "/partner-with-us",
      },
      {
        name: "Privacy",
        url: "/privacy",
      },
      {
        name: "Terms",
        url: "/terms",
      },
    ],
    helpPages: [
      {
        name: "Customer stories",
        url: "/customer-stories",
      },
      {
        name: "How it Works",
        url: "/how-it-works",
      },
      {
        name: "Contact us",
        url: "/contact-us",
      },
      {
        name: "About us",
        url: "/about",
      }
    ],
  }),
};
</script>

<style lang="scss">
.text-right-custome {
  text-align: right;
}
@media only screen and (max-width: 940px) {
  .text-center-custome {
    text-align: center !important;
  }
  .margin-auto-0 {
    margin: 0 auto !important;
  }
}
</style>
